<template>
  <div class="task_info">
    <!-- 滚动通知 -->
    <div class="noitce_bar">
      <van-notice-bar :scrollable="false">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :touchable="false"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, index) in state.otherLog" :key="index">
            恭喜玩家
            <span style="color:#FF7517 ;">{{ item.nickname }}</span>
            获得
            <span style="color:#FF7517 ;">{{ item.remarks }}</span>
          </van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>
    <!-- 任务信息 -->
    <div class="task_detail">
      <div class="task_one">
        <p>登陆0.1折《{{ state.gameName }}》游戏</p>
        <span
          class="task_btn"
          v-if="!state.activityStatus"
          @click="goGamedetails"
          >未开始
        </span>
        <span
          class="task_btn"
          v-else-if="state.activityStatus && !state.isLogin"
          @click="goGamedetails"
          >去完成
        </span>
        <span class="task_btn get" v-else>已完成</span>
      </div>
      <div class="task_two">
        <p>在0.1折《{{ state.gameName }}》充值6元</p>
        <span
          class="task_btn"
          v-if="!state.activityStatus"
          @click="goGamedetails"
          >未开始
        </span>
        <span
          class="task_btn"
          v-else-if="state.activityStatus && !state.isPay"
          @click="goGamedetails"
          >去完成
        </span>
        <span class="task_btn get" v-else>已完成</span>
      </div>
    </div>
  </div>

  <div class="game_video">
    <div class="video_info">
      <video
        class="my_video"
        :src="state.video_url"
        :poster="state.poster"
        preload="none"
        playsinline
        controls
        :key="state.videoKey"
      ></video>
    </div>
  </div>
</template>
<script setup>
import { reactive, watch } from "vue";
import { detect } from "@/utils/device";
const state = reactive({
  video_url: "http://zz.5535.cn/blby01zzbfzsg.mp4",
  // video_url: "",
  poster: "https://oss.aiqu.com/data/upload/game/20240814/66bc6699d2fd2.jpg",
  // poster: "",
  isLogin: false,
  isPay: false,
  otherLog: [],
  gameName: "百龙霸业",
  videoKey: 0,
  activityStatus: 0,
  gid: "",
});

const props = defineProps({
  video_url: {
    type: String,
    default: "",
  },
  poster: {
    type: String,
    default: "",
  },
  isLogin: {
    type: Number,
    default: false,
  },
  isPay: {
    type: Number,
    default: false,
  },
  otherLog: {
    type: Array,
    default: [],
  },
  gameName: {
    type: String,
    default: "",
  },
  activityStatus: {
    type: Number,
    default: 0,
  },
  gid: {
    type: String,
    default: "",
  },
});

// 监听
watch(props, (newVal, oldVal) => {
  // console.log("值改变了", newVal);
  ++state.videoKey;
  // state.video_url = newVal.video_url;
  // state.poster = newVal.poster;
  state.otherLog = newVal.otherLog;
  state.gid = newVal.gid;
  if (newVal.gameName == "") {
    state.gameName = "《鸡你太美》";
  } else {
    state.gameName = newVal.gameName;
  }
  if (newVal.isLogin == 2) {
    state.isLogin = true;
  } else {
    state.isLogin = false;
  }
  if (newVal.isPay == 2) {
    state.isPay = true;
  } else {
    state.isPay = false;
  }
  if (newVal.activityStatus == 1) {
    state.activityStatus = true;
  } else {
    state.activityStatus = false;
  }
  // console.log("值改变了", state.video_url);
});
// 跳转到游戏详情页
const goGamedetails = () => {
  if (detect() == "android" || detect() == "harmony") {
    window.document.location = "gogame://" + props.gid;
  } else {
    var eventData = {
      eventType: "openEvent",
      gid: props.gid,
    };
    window.parent.postMessage(eventData, "*");
  }
  // console.log("跳转到游戏详情页--------", state.gid);
};
</script>
<style scoped>
.task_info {
  height: 480px;
  position: relative;
}
.task_info .noitce_bar {
  width: 100%;
  /* height: 108px; */
  position: absolute;
  top: -44px;
  /* background: url(../../../assets/webActivity/homeThreeGame/icon_transition.png); */
  background-size: 100% 100%;
}
.van-notice-bar {
  background: rgba(0, 0, 0, 0);
}
:deep(.van-notice-bar__wrap) {
  justify-content: center;
}
:deep(.van-swipe-item) {
  text-align: center;
}
.notice-swipe {
  height: 40px;
  line-height: 40px;
  color: #fff;
  display: flex;
  justify-content: center;
}

/* 任务信息 */
.task_detail {
  height: 480px;
  background-image: url("../../../assets/webActivity/homeThreeGame/test3.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 50px;
}
.task_detail div {
  display: flex;
  height: 96px;
  font-size: 24px;
  color: #fff;
}
.task_detail div p {
  width: 440px;
  padding: 28px 0 0 76px;
}
.task_detail .task_btn {
  display: inline-block;
  width: 190px;
  /* background-image: url("../../../assets/webActivity/homeThreeGame/icon_taskbtn.png"); */
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
}
.task_detail .task_one p {
  background-image: url("../../../assets/webActivity/homeThreeGame/icon_taskOne.png");
  background-size: 100% 100%;
}
.task_detail .task_two p {
  background-image: url("../../../assets/webActivity/homeThreeGame/icon_taskTwo.png");
  background-size: 100% 100%;
}
.task_detail .get {
  /* background-image: url("../../../assets/webActivity/homeThreeGame/icon_taskbtn_get.png"); */
  color: #cccccc;
}

/* 视屏区域 */
.game_video {
  height: 580px;
  width: 100%;
  position: relative;
  background: url("../../../assets/webActivity/homeThreeGame/test4.png");
  background-size: 100% 100%;
  padding: 164px 0 0 44px;
}
.game_video .video_info {
  width: 663px;
  height: 375px;
}
.game_video .video_info video {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.my_video {
  width: 100%;
  object-fit: cover;
}
</style>
